const SESSION_KEY = "itr_auth_session";
/** Обновить access token за 60 с до истечения. */
export const ACCESS_TOKEN_REFRESH_BUFFER_MS = 60000;
export const AUTH_SESSION_UPDATED_EVENT = "itr:auth-session-updated";
export const AUTH_SESSION_CLEARED_EVENT = "itr:auth-session-cleared";
const withExpiry = (session) => ({
    ...session,
    access_token_expires_at: Date.now() + Math.max(0, session.expires_in) * 1000,
});
export const sessionStorageService = {
    get() {
        const raw = localStorage.getItem(SESSION_KEY);
        if (!raw)
            return null;
        try {
            return JSON.parse(raw);
        }
        catch {
            localStorage.removeItem(SESSION_KEY);
            return null;
        }
    },
    set(session, options) {
        const stored = withExpiry(session);
        localStorage.setItem(SESSION_KEY, JSON.stringify(stored));
        if (options?.notify && typeof window !== "undefined") {
            window.dispatchEvent(new CustomEvent(AUTH_SESSION_UPDATED_EVENT, { detail: stored }));
        }
    },
    clear(options) {
        localStorage.removeItem(SESSION_KEY);
        if (options?.notify && typeof window !== "undefined") {
            window.dispatchEvent(new CustomEvent(AUTH_SESSION_CLEARED_EVENT));
        }
    },
    isAccessTokenExpired(session, bufferMs = ACCESS_TOKEN_REFRESH_BUFFER_MS) {
        if (!session?.access_token)
            return true;
        if (!session.access_token_expires_at)
            return true;
        return Date.now() >= session.access_token_expires_at - bufferMs;
    },
};
